import request from '../services/request';

export const create = params => request.post('/course-promotions/', params);
